export function BillingPolicy() {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Billing Policy</h1>
        <p className="legal-updated">Last updated: February 14, 2026</p>

        <div className="legal-content">
          <h2>Subscription Billing Model</h2>
          <p>
            CryptoGuardians operates on a subscription-based SaaS billing model. By subscribing, you
            agree to the following billing terms.
          </p>

          <h2>Recurring Billing</h2>
          <ul>
            <li>Subscriptions are billed on a monthly recurring basis.</li>
            <li>
              All payments are processed securely through{' '}
              <a href="https://stripe.com" target="_blank" rel="noopener noreferrer">
                Stripe, Inc.
              </a>
            </li>
            <li>
              Your subscription automatically renews at the end of each billing cycle unless you cancel
              before the renewal date.
            </li>
            <li>Prices are listed in US Dollars (USD).</li>
          </ul>

          <h2>Automatic Renewal</h2>
          <p>
            Your subscription will automatically renew at the end of each billing period. You authorize
            HAJ Solutions, Inc. to charge your selected payment method for recurring subscription fees
            until you cancel. You may cancel at any time per our{' '}
            <a href="/cancellation-policy">Cancellation Policy</a>.
          </p>

          <h2>Taxes</h2>
          <p>
            Applicable taxes may be added to your subscription charge depending on your jurisdiction.
            Tax amounts, if any, will be displayed during checkout.
          </p>

          <h2>Charge Disputes</h2>
          <p>
            If you believe a charge is incorrect, please contact us at{' '}
            <a href="mailto:billing@cryptoguardians.io">billing@cryptoguardians.io</a> before
            initiating a dispute with your bank or card issuer. We will work with you to resolve billing
            issues promptly.
          </p>
          <p>
            Charge disputes are handled in accordance with the Stripe dispute resolution process.
            Customers agree not to initiate fraudulent chargebacks. Fraudulent chargeback activity may
            result in account termination and further action.
          </p>

          <h2>Failed Payments</h2>
          <p>
            If a scheduled payment fails, we may attempt to process the charge again. If payment cannot
            be collected after reasonable attempts, your subscription may be suspended or cancelled.
          </p>

          <h2>Price Changes</h2>
          <p>
            We reserve the right to change subscription pricing with at least 30 days advance notice.
            Price changes will take effect at the start of your next billing cycle following the notice
            period.
          </p>

          <h2>Billing Contact</h2>
          <p>
            For billing questions, invoice requests, or payment issues, contact us at{' '}
            <a href="mailto:billing@cryptoguardians.io">billing@cryptoguardians.io</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
